import { Twitter, Instagram, Youtube, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-black pt-16 pb-24 md:pb-12"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-12 mb-12">
          <div>
            <a href="#top" className="inline-block mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_day-trade-ebook-1/artifacts/9f44l5ze_ChatGPT%20Image%20Jun%2029%2C%202026%2C%2011_26_30%20PM.png"
                alt="The 9-to-5 Exit Blueprint"
                className="h-20 w-auto object-contain"
              />
            </a>
            <p className="text-white/50 text-sm leading-relaxed max-w-sm">
              The 9-to-5 Exit Blueprint — a beginner-friendly visual guide to day trading,
              risk management, and building a real trading routine.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {[
                { Icon: Twitter, href: "#", label: "Twitter" },
                { Icon: Instagram, href: "#", label: "Instagram" },
                { Icon: Youtube, href: "#", label: "Youtube" },
                { Icon: Mail, href: "mailto:support@trade-flux.com", label: "Email" },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  data-testid={`social-${label.toLowerCase()}`}
                  aria-label={label}
                  className="w-9 h-9 rounded-full border border-white/10 grid place-items-center text-white/60 hover:text-emerald-400 hover:border-emerald-500/40 transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white text-sm uppercase tracking-widest mb-4">
              Navigate
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><a href="#learn" className="text-white/55 hover:text-emerald-400 transition">What You'll Learn</a></li>
              <li><a href="#inside" className="text-white/55 hover:text-emerald-400 transition">Inside the Book</a></li>
              <li><a href="#pricing" className="text-white/55 hover:text-emerald-400 transition">Pricing</a></li>
              <li><a href="#faq" className="text-white/55 hover:text-emerald-400 transition">FAQ</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white text-sm uppercase tracking-widest mb-4">
              Legal
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><a href="/refund-policy" className="text-white/55 hover:text-emerald-400 transition">Refund Policy</a></li>
              <li><a href="/license-agreement" className="text-white/55 hover:text-emerald-400 transition">License Agreement</a></li>
              <li><a href="mailto:support@trade-flux.com" className="text-white/55 hover:text-emerald-400 transition">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div
            data-testid="risk-disclaimer"
            className="rounded-xl border border-amber-500/20 bg-amber-500/5 p-5 text-xs md:text-sm text-amber-100/70 leading-relaxed"
          >
            <strong className="text-amber-300 font-display font-semibold">
              Trading Risk Disclaimer:
            </strong>{" "}
            Day trading involves substantial risk of loss and is not suitable for every investor.
            Past performance is not indicative of future results. The content of this ebook is
            educational in nature and does not constitute financial, investment, tax, or legal
            advice. You are solely responsible for any decisions made based on the information
            provided. Never trade with money you cannot afford to lose.
          </div>

          <div className="mt-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-xs text-white/40">
            <div>© 2026 9-to-5 Exit Blueprint. All rights reserved.</div>
            <div>Made for traders who'd rather trade than work.</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
